<ng-container *ngIf="componentData">
  <app-custom-newsletter [component]="componentData">
  </app-custom-newsletter>
</ng-container>
